import {
  DetailsBig,
  DetailsBigCss,
  DetailsSmall,
  ParagraphCss,
  ParagraphSmall,
  ParagraphSmallCss,
  PrimaryButtonCss,
  Wysiwyg,
  h4,
} from "@/styles/typography";
import styled from "styled-components";

const Section = styled.section`
  min-height: 70vh;
`;

const Container = styled.div`
  position: fixed;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  padding: 32px 24px;
  background-color: ${({ theme }) => theme.colors.coreLight};
  border-radius: 4px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  @media screen and (max-width: 680px) {
    width: calc(100% - 32px);
    top: 25%;
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100vh;
  background-color: black;
  opacity: 0.2;
  z-index: 999;
`;

const Title = styled(h4)`
  margin-bottom: 16px;
`;

const Text = styled(Wysiwyg)`
  ${ParagraphCss};
  margin-bottom: 36px;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const Button = styled.div`
  ${PrimaryButtonCss};
  width: 100%;
  margin: 8px 0 0 auto;

  @media screen and (min-width: 680px) {
    width: fit-content;
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.colors.coreDark};
  border-radius: 4px;
  ${ParagraphSmallCss};
  font-size: 14px;
`;

const Label = styled.label`
  ${DetailsBigCss};
  font-size: 14px;
`;

const WrongPassword = styled(DetailsBig)``;

const S = {
  Section,
  Container,
  Overlay,
  Title,
  Text,
  ButtonsWrapper,
  Button,
  Input,
  Label,
  WrongPassword,
};

export default S;
